import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CongratulationComponent } from 'src/app/shared/components/congratulation/congratulation.component';
import { EdittedSuccessfullyComponent } from 'src/app/shared/components/editted-successfully/editted-successfully.component';

@Injectable({
  providedIn: 'root'
})
export class ProductCreationHelperService {
  constructor(private Dialog: MatDialog) {}

  async checkParamsForOpriningCopyDialog(location: string, data: ProductDialogData){
    const params = new URLSearchParams(location);
      const showWindow = params.get('showWindow');
      if(showWindow){
        await this.openShareButtonsDialog(showWindow, data)
      }
  }

  private async openShareButtonsDialog(showWindow: string | "create" | "update", data: ProductDialogData) {
    const compinent: any = showWindow === "update" ? EdittedSuccessfullyComponent : CongratulationComponent;
    const dialogRef = this.Dialog.open(compinent, {
      panelClass: "responsive-dialog",
      data: {
        url: data.serilizedUrl,
        name: data.product.name || "",
        type: data.product.type,
        showCongratulation: false,
        showButton: false
      }
    });
  }
} 

export interface ProductDialogData {
    serilizedUrl: string;
    product: {
      name: string;
      type: string;
    };
  }